var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3463 22.0962L20.8614 18.6115C21.8219 17.2125 22.3871 15.5144 22.3866 13.6935C22.3874 11.2984 21.4108 9.11432 19.8403 7.54632C18.2724 5.97591 16.0883 4.99931 13.693 5C11.2979 4.99931 9.11381 5.97574 7.54615 7.54632C5.97574 9.11415 4.99931 11.2983 5 13.6935C4.99931 16.089 5.97574 18.2729 7.54632 19.8406C9.11415 21.4112 11.2983 22.3878 13.6932 22.3867C15.4343 22.3874 17.0623 21.8699 18.4246 20.9854L21.9409 24.5014C22.6051 25.1662 23.682 25.1662 24.3461 24.5014C25.0109 23.8373 25.0109 22.7604 24.3463 22.0962ZM9.95172 17.4352C8.99158 16.4725 8.40275 15.1601 8.40189 13.6935C8.40275 12.227 8.99158 10.9148 9.95189 9.95189C10.9148 8.99158 12.2268 8.40275 13.6932 8.40189C15.1599 8.40275 16.472 8.99158 17.435 9.95172C18.3952 10.9148 18.984 12.2268 18.9847 13.6935C18.984 15.1601 18.3952 16.4725 17.435 17.4352C16.4721 18.3955 15.1601 18.9842 13.6932 18.9849C12.2268 18.9842 10.9148 18.3955 9.95172 17.4352Z",
    fill: "#583BE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1fc19bad6a40c48a4575934066f05cf1.svg";
export { ForwardRef as ReactComponent };